export function detectFileType(fileType, fileName) {
    const lower = (v) => (v ? v.toLowerCase() : "");
  
    const name = lower(fileName);
    const type = lower(fileType);
  
    const isImage =
      type.includes("image") ||
      /\.(jpg|jpeg|png|gif|webp)$/i.test(name);
  
    const isVideo =
      type.includes("video") ||
      /\.(mp4|avi|mov|wmv)$/i.test(name);
  
    const isPDF =
      type.includes("pdf") ||
      name.endsWith(".pdf");
  
    return { isImage, isVideo, isPDF };
  }
  